
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";

export default Vue.extend({
  data() {
    return {
      title: "Ambassadors | Bikeflights.com",
    };
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "ambassadors",
          name: "ambassadors",
          content:
            "We support individual cyclists and teams who inspire others to achieve and to adventure. Our Ambassadors aren't just ambassadors for Bikeflights; they are ambassadors for the sport of cycling that we all love.",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      ambassadors: "ambassadors",
    }),
  },
  methods: {
    ...mapActions({
      getAmbassadors: "getAmbassadors",
    }),
  },
  created() {
    this.getAmbassadors();
  },
});
